// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"13462114","732":"d5017ffe","977":"b4201630"}[chunkId] + ".chunk.js";
};